import { render, staticRenderFns } from "./RoomViewer.vue?vue&type=template&id=07df2d9c&"
import script from "./RoomViewer.vue?vue&type=script&lang=js&"
export * from "./RoomViewer.vue?vue&type=script&lang=js&"
import style0 from "./RoomViewer.vue?vue&type=style&index=0&id=07df2d9c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports